/**
 * Mirrors Modules\Community\Enums\AssetCategory (PHP).
 * @enum {string}
 */
export const AssetCategory = {
  PLAYLIST_BANNER: "playlist_banner",
  COMMUNITY_HERO: "community_hero",
  COMMUNITY_BANNER: "community_banner",
  SECTION_BANNER: "section_banner",
  SECTION_HERO: "section_hero",
  CONTENT_BANNER: "content_banner",
  GROUP_BANNER: "group_banner",
  GROUP_POST: "group_post",
  MATERIAL_CONTENT: "material_content",
  MATERIAL_BANNER: "material_banner",
};
